import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faMapMarkerAlt, faLanguage, faToolbox, faHeart, faBriefcase, faGraduationCap, faLink } from '@fortawesome/free-solid-svg-icons';
import initialStyles from '../settings/initialStyles';
import { linkIcons, linkText } from '../settings/linkData';
import ThemeConfigPanel from '../settings/ThemeConfigPanel';
import Notification from '../components/notification/Notification';

import 'react-circular-progressbar/dist/styles.css';
import '../styles/TemplateThree.css';

const themePresets = {
    default: initialStyles,
    dark: {
        backgroundColor: '#333',
        secondaryBackgroundColor: '#555',
        headerBackgroundColor: '#222',
        headerTextColor: '#fff',
        subheaderTextColor: '#555',
        textColor: '#eee',
        headerFontSize: '1.6',
        subheaderFontSize: '1.5',
        bodyFontSize: '1'
    },
    light: {
        backgroundColor: '#f9f9f9',
        secondaryBackgroundColor: '#e0e0e0',
        headerBackgroundColor: '#ddd',
        headerTextColor: '#333',
        subheaderTextColor: '#555',
        textColor: '#111',
        headerFontSize: '1.6',
        subheaderFontSize: '1.5',
        bodyFontSize: '1'
    }
};

const ViewTemplateThree = ({ template, isDownloading }) => {
    const [styles, setStyles] = useState(initialStyles);
    const [notification, setNotification] = useState(null);

    const handleStyleChange = (e) => {
        const { name, value } = e.target;
        setStyles((prevStyles) => ({
            ...prevStyles,
            [name]: value,
        }));
    };

    const applyPreset = (preset) => {
        setStyles(themePresets[preset]);
    };

    const saveCustomTheme = () => {
        localStorage.setItem('customTheme', JSON.stringify(styles));
        setNotification({ message: 'Custom theme saved!', isError: false });
    };

    const loadCustomTheme = () => {
        const customTheme = localStorage.getItem('customTheme');
        if (customTheme) {
            setStyles(JSON.parse(customTheme));
            setNotification({ message: 'Custom theme loaded!', isError: false });
        } else {
            setNotification({ message: 'No custom theme found!', isError: true });
        }
    };



    const templateData = template || {};

    const skillsWithLevels = (templateData?.skills || []).map(skill => ({
        name: skill,
        level: Math.floor(Math.random() * 11) + 90

    }));

    const softwareSkillsWithLevels = (templateData?.softwareSkills || []).map(skill => ({
        name: skill,
        level: Math.floor(Math.random() * 11) + 90

    }));

    const baseUrl = process.env.REACT_APP_API_BASE_URL || 'https://venusresume.vercel.app/';
    const imageUrl = templateData?.image?.startsWith('/')
        ? `${baseUrl}${templateData.image}`
        : templateData.image;
    return (
        <div className='holder'>

            {notification && (
                <Notification
                    message={notification.message}
                    isError={notification.isError}
                    onClose={() => setNotification(null)}
                />
            )}

            <div className="template-three-container" style={{ backgroundColor: styles.backgroundColor }}>
                <div className="template-three-header" style={{ backgroundColor: styles.headerBackgroundColor, color: styles.headerTextColor }}>
                    {imageUrl && <img src={imageUrl} alt={templateData.personName} className="template-three-image" />}
                    {templateData.personName && <h1 className="template-three-name" style={{ fontSize: `${styles.headerFontSize}em`, color: styles.headerTextColor }}>{templateData.personName}</h1>}
                </div>
                <div className="template-three-details">
                    <div>
                        <strong style={{ fontSize: `${styles.subheaderFontSize}em`, color: styles.subheaderTextColor }}> About Me</strong>
                        {templateData.aboutMe && <p className="template-three-about" style={{ fontSize: `${styles.bodyFontSize}em`, color: styles.textColor }}>{templateData.aboutMe}</p>}
                    </div>

                    {templateData.languages && (
                        <div className="template-three-section">
                            <strong style={{ fontSize: `${styles.subheaderFontSize}em`, color: styles.subheaderTextColor }}>Contacts:</strong>
                            {templateData.contact.email && <p><FontAwesomeIcon icon={faEnvelope} style={{ fontSize: `${styles.bodyFontSize}em` }} /> {templateData.contact.email}</p>}
                            {templateData.contact.phone && <p><FontAwesomeIcon icon={faPhone} style={{ fontSize: `${styles.bodyFontSize}em` }} /> {templateData.contact.phone}</p>}
                            {templateData.contact.address && <p><FontAwesomeIcon icon={faMapMarkerAlt} style={{ fontSize: `${styles.bodyFontSize}em` }} /> {templateData.contact.address}</p>}                        </div>
                    )}


                    {templateData.languages && (
                        <div className="template-three-section">
                            <strong style={{ fontSize: `${styles.subheaderFontSize}em`, color: styles.subheaderTextColor }}><FontAwesomeIcon icon={faLanguage} /> Languages:</strong>
                            <p style={{ fontSize: `${styles.bodyFontSize}em` }}>{templateData.languages.join(', ')}</p>
                        </div>
                    )}
                    {templateData.skills && (
                        <div className="template-three-section">
                            <strong style={{ fontSize: `${styles.subheaderFontSize}em`, color: styles.subheaderTextColor }}><FontAwesomeIcon icon={faToolbox} /> Skills:</strong>
                            <div className="template-three-skills-wrapper">
                                {skillsWithLevels.map((skill, index) => (
                                    <div key={index} className="template-three-skill-item">
                                        <span className="template-three-skill-name" style={{ fontSize: `${styles.bodyFontSize}em` }}>{skill.name}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {templateData.softwareSkills && templateData.softwareSkills.length > 0 && (
                        <div className="template-three-section">
                            <strong style={{ fontSize: `${styles.subheaderFontSize}em`, color: styles.subheaderTextColor }}><FontAwesomeIcon icon={faToolbox} /> Software Skills:</strong>
                            <div className="template-three-skills-wrapper">
                                {softwareSkillsWithLevels.map((skill, index) => (
                                    <div key={index} className="template-three-skill-item">
                                        <span className="template-three-skill-name" style={{ fontSize: `${styles.bodyFontSize}em` }}>{skill.name}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {templateData.hobbies && (
                        <div className="template-three-section">
                            <strong style={{ fontSize: `${styles.subheaderFontSize}em`, color: styles.subheaderTextColor }}><FontAwesomeIcon icon={faHeart} /> Hobbies:</strong>
                            <p style={{ fontSize: `${styles.bodyFontSize}em` }}>{templateData.hobbies.join(', ')}</p>
                        </div>
                    )}
                    {templateData.workExperience && templateData.workExperience.length > 0 && (
                        <div className="template-three-section">
                            <strong style={{ fontSize: `${styles.subheaderFontSize}em`, color: styles.subheaderTextColor }}><FontAwesomeIcon icon={faBriefcase} /> Work Experience:</strong>
                            {templateData.workExperience.map((experience, index) => (
                                <div key={index} className="template-three-work-experience-item">
                                    {experience.role && <p className="template-three-role" style={{ fontSize: `${styles.bodyFontSize}em` }}>{experience.role} at {experience.company}</p>}
                                    {experience.location && (
                                        <p style={{ fontSize: `${styles.bodyFontSize}em` }}>
                                            {experience.location} (
                                            {experience.startDate && new Date(experience.startDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })} -
                                            {experience.endDate !== "Present" ? new Date(experience.endDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Present'}
                                            )
                                        </p>
                                    )}
                                    {experience.description && <p className="template-three-description" style={{ fontSize: `${styles.bodyFontSize}em` }}>{experience.description}</p>}
                                </div>
                            ))}
                        </div>
                    )}
                    {templateData.education && Array.isArray(templateData.education) && templateData.education.length > 0 && (
                        <div className="template-three-section">
                            <strong style={{ fontSize: `${styles.subheaderFontSize}em`, color: styles.subheaderTextColor }}><FontAwesomeIcon icon={faGraduationCap} /> Education:</strong>
                            {templateData.education.map((edu, index) => (
                                <div key={index} className="template-three-work-experience-item">
                                    {edu.degree && <p className="template-three-degree" style={{ fontSize: `${styles.bodyFontSize}em` }}>{edu.degree} from {edu.institution}</p>}
                                    <p style={{ fontSize: `${styles.bodyFontSize}em`, fontWeight: "200" }}>
                                        (
                                        {edu.startDate && new Date(edu.startDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })} -
                                        {edu.endDate !== "Present" ? new Date(edu.endDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Present'}
                                        )
                                    </p>
                                    {edu.description && <p className="template-three-description" style={{ fontSize: `${styles.bodyFontSize}em` }}>{edu.description}</p>}
                                </div>
                            ))}
                        </div>
                    )}

                    {templateData?.certificates && templateData.certificates.length > 0 && (
                        <div className="template-three-section">
                            <strong style={{ fontSize: `${styles.subheaderFontSize}em`, color: styles.subheaderTextColor }}> <FontAwesomeIcon icon={faGraduationCap} /> Certificates</strong>
                            {templateData.certificates.map((certification, index) => (
                                <div key={index} className="template-three-work-experience-item">
                                    {certification.title && <p className="template-three-degree" style={{ fontSize: `${styles.bodyFontSize}em` }}>Title: {certification.title}</p>}
                                    {certification.institution && <p className="description" style={{ fontSize: `${styles.bodyFontSize}em` }}>Institution: {certification.institution}</p>}
                                    {certification.DateReceived && <p style={{ fontSize: `${styles.bodyFontSize}em` }}>
                                        Date Received: {new Date(certification.DateReceived).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                                    </p>}

                                </div>
                            ))}
                        </div>
                    )}


                    {templateData.links && (
                        <div className="template-three-section">
                            <strong style={{ fontSize: `${styles.subheaderFontSize}em`, color: styles.subheaderTextColor }}>Links:</strong>
                            <div className="template-three-links">
                                {Object.entries(templateData.links).map(([key, value]) => (
                                    <p key={key} className="template-three-link">
                                        <FontAwesomeIcon icon={linkIcons[key] || faLink} />
                                        <a href={value} target="_blank" rel="noopener noreferrer">
                                            <span className="template-three-link-text" style={{ fontSize: `${styles.bodyFontSize}em` }}>{linkText[key]}</span>
                                        </a>
                                    </p>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {!isDownloading && (
                <ThemeConfigPanel
                    styles={styles}
                    handleStyleChange={handleStyleChange}
                    applyPreset={applyPreset}
                    saveCustomTheme={saveCustomTheme}
                    loadCustomTheme={loadCustomTheme}
                />
            )}
        </div>
    );
};

export default ViewTemplateThree;
